'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _quiverAssets = require('@surfline/quiver-assets');

var _quiverAssets2 = _interopRequireDefault(_quiverAssets);

var _CamOverlay = require('../CamOverlay');

var _CamOverlay2 = _interopRequireDefault(_CamOverlay);

var _CamRewind = require('../CamRewind');

var _CamRewind2 = _interopRequireDefault(_CamRewind);

var _ErrorIcon = require('./ErrorIcon');

var _ErrorIcon2 = _interopRequireDefault(_ErrorIcon);

var _AspectRatioContent = require('../AspectRatioContent');

var _AspectRatioContent2 = _interopRequireDefault(_AspectRatioContent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CamError = function CamError(_ref) {
  var message = _ref.message,
      rewindUrl = _ref.rewindUrl;
  return _react2.default.createElement(
    'div',
    { className: 'quiver-cam-error' },
    rewindUrl ? _react2.default.createElement(_CamRewind2.default, { href: rewindUrl }) : null,
    _react2.default.createElement(
      _AspectRatioContent2.default,
      null,
      _react2.default.createElement(_CamOverlay2.default, { backgroundImage: 'url(' + _quiverAssets2.default + '/backgrounds/cam-down-bg-image.png)' }),
      _react2.default.createElement(
        'div',
        { className: 'quiver-cam-error__message' },
        _react2.default.createElement(
          'div',
          { className: 'quiver-cam-error__message__subtext' },
          message
        ),
        _react2.default.createElement(_ErrorIcon2.default, null)
      )
    )
  );
};

CamError.propTypes = {
  message: _propTypes2.default.string,
  rewindUrl: _propTypes2.default.string
};

CamError.defaultProps = {
  message: 'We apologize, we are working to restore service ASAP.',
  rewindUrl: null
};

exports.default = CamError;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamError/CamError.js
// module id = 531
// module chunks = 11